import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["field"];

  connect() {
    var iti = intlTelInput(this.fieldTarget, {
      initialCountry: "auto",
      geoIpLookup: this.getIp,
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
      hiddenInput: "user[resume_attributes][whatsapp]",
      preferredCountries: ["us", "ar"],
    });

    document
      .querySelector("#verify-whatsapp")
      .addEventListener("click", function () {
        this.href = "https://api.whatsapp.com/send?phone=" + iti.getNumber();
      });
  }

  getIp(callback) {
    fetch("https://ipinfo.io/json?token=112c97a840e402", {
      headers: { Accept: "application/json" },
    })
      .then((resp) => resp.json())
      .catch(() => {
        return {
          country: "us",
        };
      })
      .then((resp) => callback(resp.country));
  }
}
